import { createAsyncThunk } from "@reduxjs/toolkit";
import api, { normalizeError } from "../../services/api";

export const createAdmin = createAsyncThunk(
  "users/createAdmin",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/api/users/admin", payload);
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const createAgent = createAsyncThunk(
  "users/createAgent",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/api/users/agent", payload);
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const updateAdmin = createAsyncThunk(
  "users/updateAdmin",
  async ({ id, ...payload }, { rejectWithValue }) => {
    try {
      const { data } = await api.put(`/api/users/admin/${id}`, payload);
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const updateAgent = createAsyncThunk(
  "users/updateAgent",
  async ({ id, ...payload }, { rejectWithValue }) => {
    try {
      const { data } = await api.put(`/api/users/agent/${id}`, payload);
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const fetchAdmins = createAsyncThunk(
  "users/fetchAdmins",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/api/users/admins");
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const fetchAgents = createAsyncThunk(
  "users/fetchAgents",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/api/users/agents");
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (userId, { rejectWithValue }) => {
    try {
      await api.delete(`/api/users/${userId}`);
      return userId;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);
